import { styledWithTheme } from "../../context";
import { A11Y_INLINE_MIN_SIZE, px } from "../../utils";
import { CheckboxColorScheme } from "../";
import { CHECKBOX_BORDER_WIDTH } from "../constants";
import { getBorderColor, getTickColor } from "../utils";
export var Tick = styledWithTheme('div')(function (_ref) {
  var selectors = _ref.theme.selectors,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error;
  var isInverted = colorScheme === CheckboxColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var borderColor = getBorderColor(getColorParams);
  var tickStrokeColor = getTickColor(getColorParams);
  return {
    border: "".concat(px(CHECKBOX_BORDER_WIDTH), " solid ").concat(borderColor),
    width: px(A11Y_INLINE_MIN_SIZE),
    height: px(A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    position: 'absolute',
    top: px(selectors.space('S300')),
    right: px(selectors.space('S300')),
    transition: 'border-color 0.1s, background-color 0.1s, box-shadow 0.1s',
    svg: {
      display: 'block',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      '.tick': {
        stroke: tickStrokeColor,
        strokeDasharray: '0, 20000',
        opacity: 0,
        transition: 'stroke-dasharray 0.1s, opacity 0.1s',
        transitionTimingFunction: 'ease-in'
      }
    }
  };
});
export default Tick;